import ProfilePicture from './ProfileImage';

export default ProfilePicture;
